import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class PerformanceTeamReviewsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'PerformanceTeamReviewsStateModel';

    constructor() {
        super(PerformanceTeamReviewsStateModel.identifier);
    }
}
